import React from "react";
import {
  Typography,
  Divider,
} from "@mui/material";
import Jordan from "../images/Jordan.png"
import TwitterEmbed from "../TwitterEmbed";

export default function Article2(props: any) {

  return (
    <div>
      <title>"Who'd We Get?" - A Recap of the Red Sox Trade Deadline (ft. Griffey Geiss (@ggeiss_mlb))</title>
      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          color: "#000000",
          textAlign: "center",
          fontSize: props.isDesktop ? "32pt" : "20pt",
        }}
      >
        "Who'd We Get?" - A Recap of the Red Sox Trade Deadline (ft. Griffey Geiss (@ggeiss_mlb))
      </Typography>
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          fontSize: props.isDesktop ? "18pt" : "14pt",
        }}
      >
        By Griffey Geiss • August 17th, 2025
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />

      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Red Sox fans had sky-high expectations heading into the 2025 trade deadline — some too high — yet the team came away with a relatively light return of talent, causing an uproar. It’s not necessarily that the players were bad, more so that the fanbase and perhaps even some of the players in the locker room were expecting more.
        <br /><br />
        With that being said, they did improve their team in hopes of finally returning to the playoffs for the first time since their magical 2021 season. Let’s take a deeper look into who they acquired and the price they had to pay…
        <br /><br />
      </Typography>


      {/* Matz Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Cardinals Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>1B/3B Blaze Jordan</div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Red Sox Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>LHP Steven Matz</div>
        </div>
      </div> <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        In their first move, the day before all chaos broke loose, Boston acquired veteran left-hander Steven Matz from the Cardinals in exchange for corner infield prospect Blaze Jordan (<a href="https://medium.com/@ggeiss_mlb/post-draft-update-red-sox-top-50-prospects-c06ca87c4286">31st ranked Red Sox prospect via my post-draft update</a>).
      </Typography><br />
      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        LHP Steven Matz
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Matz, 34, is a cheap left-hander with postseason experience (2.18 FIP in 14+ IP) that has the ability to work in bulk and has excelled this season. Prior to the trade, he owned a 3.44 ERA, 1.18 WHIP, and miniscule 4% BB rate. The underlying stuff outside of the ERA was phenomenal, too — a stellar 2.88 FIP, 3.09 xERA, and 29% CSW rate — which is what made him so appealing to the Red Sox, which had seen an overworked bullpen take a major toll on its team post-ASB in the season prior.
        <br /><br />
        Chief Baseball Officer Craig Breslow loves southpaws with good extension and the ability to work well in-zone… that’s exactly what Steven Matz is. His 6’5” extension remains above league average, and both his 61% zone rate (94th percentile among MLB RPs) and 67% strike rate (87th) are what make him so effective. He also owned a 6% barrel rate, .277 xwOBA, 5.17 PLV, and 2.63 PLA prior to the trade, all of which ranked inside the top 15% of major league arms.
        <br /><br />
        Matz’s arsenal is headlined by a sinker that’s used 60% of the time (95th percentile among RPs) that showcases elite command (117 Loc+) and plays up in the zone thanks to his extension and a 0.6° HAVAA. It grades out at a 5.2 PLV which is beyond exceptional. He also has a curveball, being his best whiff pitch (25% whiff / 31% CSW), a changeup (.224 xBA vs. RHB), and a slider (50% whiff vs. LHB despite its small usage rate).
        <br /><br />
        Since the deal he’s been excellent, turning in 4.2 scoreless innings of relief with 3 Ks, a 0.64 WHIP, 34% CSW, and a 42% GB rate. His curveball Stuff+ ticked up to 119 with a 39% CSW rate on 31% usage. It’s safe to say this deal looks really good thus far.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        1B/3B Blaze Jordan
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        In order to pry away Matz, the Red Sox had to reunite mid tier prospect Blaze Jordan with former CBO Chaim Bloom. I should note, multiple sources suggest that this isn’t the first time Bloom attempted to acquire Jordan in St. Louis, even trying to send Nolan Arenado out for a package surrounded around the likes of Jordan and Nazzan Zanetello (another Bloom draft pick) had Boston not landed Alex Bregman in free agency.
        <br /><br />
        The 22-year-old has turned in perhaps the best production of his young career this year which made him such an intriguing asset at the deadline. Prior to the trade, Jordan slashed .298/.341/.480 with a 114 wRC+, boasting top tier K-limitation (10%) and walking at a 6% clip. He tallied 18 XBH and 25 RBI in Triple-A with a 36% HH rate albeit a 4% barrel rate and .301 xwOBA.
        <br /><br />
        Admittedly, I wasn’t particularly sold on Jordan as a major league option. He limits Ks well (95th percentile in Triple-A, according to Prospect Savant), but he’s a bat-reliant prospect with limited athleticism that hasn’t displayed much pop through his minor league career. His 13th percentile aEV (84 mph), 31st percentile HH%, and 39% barrel rate are prime examples.
        <br /><br />
        I’m not all the way out on Jordan, however. He swings often (90th percentile) which causes a high chase rate (19th percentile), but he doesn’t rack up many whiffs (88th percentile) against Triple-A pitching. If he could manage to improve the lackluster xwOBA and start hammering the ball in the air with authority, perhaps trading in a tad bit of that K%, he could find himself in a bench corner infield role in the future.
        <br /><br />
        Jordan hasn’t been great since the trade, posting a wRC+ of 8 with a .143/.184/.257 slash line.
        <br /><br />
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Jordan}
            alt="Blaze Jordan"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>
      </Typography>

      {/* May Trade */}
      <div style={{
        margin: "20px 0",
        padding: "15px",
        backgroundColor: "#f8f9fa",
        borderLeft: "4px solid #0d6efd",
        borderRadius: "4px"
      }}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Dodgers Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>
            OF James Tibbs III,<br />
            OF Zach Ehrhard
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Red Sox Receive:</div>
          <div style={{ flex: 2, fontSize: "14pt" }}>RHP Dustin May</div>
        </div>
      </div>
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        After a longgggg wait for a move, with ~10 minutes left in the day, Breslow & Co. managed to sneak one more trade in, acquiring the talented but oft-injured Dustin May in exchange for two really underrated outfield prospects, James Tibbs III and Zach Ehrhard (<a href="https://medium.com/@ggeiss_mlb/post-draft-update-red-sox-top-50-prospects-c06ca87c4286">my 11th and 29th ranked Red Sox prospects)</a>.
        <br /><br />
        This is the deal that got fans upset. Waiting forever to make a move, pursuing controllable targets like Joe Ryan and Sandy Alcantara all day, and panicking to overpay for an inconsistent rental that was in need of some arsenal tweaks off rip. Looking back on the trade, it’s still an overpay but the idea wasn’t bad… it was more of the fact they could’ve done better.
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        RHP Dustin May
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        May was a sleeper acquisition. The 28-year-old is a rental and had a rough go with the Dodgers, turning in a 4.85 ERA/4.7 FIP with a 1.35 WHIP in 104 innings, by far and away his career-high and more than he totaled from 2021-2024 combined (101 IP). Prior to this season, May had been a pretty good starter when healthy. He turned in a 3.10 ERA/3.70 FIP, 1.05 WHIP, .205 BAA, and 23% K rate on 50% GB and 28% CSW rates.
        <br /><br />
        His arsenal drew comparisons to current Red Sox arms like Brayan Bello and Tanner Houck according to Baseball Savant’s affinity tool. His stuff grades have regressed, going from a career 112 Stuff+ arm headlined by a sinker that sits 98–99 mph, to an average 100 Stuff+ arm sitting 96-97 mph after dropping his arm angle ten degrees this year. With that being said, the sinker (19" HB) and sweeper (17" HB) move really well horizontally. He also utilizes a four-seamer and cutter. May’s struggle(s) are interesting — it’s K% against RHBs but BB% against LHBs — and his overall numbers are inflated after a disastrous June.
        <br /><br />
        May’s sweeper is the headliner, boasting a .209 xBA, .257 xwOBA, and 29% whiff rate in 2025. The great part about this offering is that it’s been good against righties, lefties, ahead in counts, behind, even, or in two strike situations. His sinker is fine but not what it once was, and the Sox identified that leaning more on the four-seamer (.111 BAA, .266 xwOBA, 26% whiff prior to the trade). His 1.3° HAVAA helps it play well at the top of the zone.
        <br /><br />
        What’s made May so effective with Boston is the major reliance on the cutter, setting up hitters well in-zone and letting the out-of-zone stuff like his FF (elevated), SI (sparingly used to zone on corners) and SW play up even more. A nifty 20% increase in first-pitch strikes since joining BOS has worked wonders, plus the IZ-sequencing has allowed his OOZ effectiveness to thrive — whiffs on shadow (27%) and chase pitches (80%) are WAY up.
        <br /><br />
        Since he was acquired, May has turned into a whole new arm through two starts, even despite getting BABIP’d like crazy allowing a handful of dinky hits in the first one. It’s been amazing to see and also a sigh of relief that these next two prospects weren’t dealt for nothing.
        {/* Embedded Tweet */}
        <div style={{ textAlign: "center", margin: "auto" }}>
          <TwitterEmbed author="ggeiss_mlb" tweetId="1955617067983679753" />
        </div>
        <br />

      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        OF James Tibbs III
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Tibbs III (part of the Rafael Devers return via San Francisco) and Ehrhard (a two-time Red Sox draft pick – 13th round in 2021, 4th round in 2024) are both plus hitters with big OBP potential.
        <br /><br />
        Tibbs III limits Ks, draws BBs, doesn’t chase, and hits the ball hard. It would be an understatement to say I’m high on this kid. He’s done a great job cutting the miss rate down by over 10% from last year. After joining Boston he was “meh” for the most part, never really finding his groove. Tibbs slashed .232/.359/.404 with a 115 wRC+ before the deal between two teams albeit awful BABIP luck (.266) and moving cross country. He was walking at a 16% clip with a 21% K rate, though that number had ticked up since being promoted to Double-A.
        <br /><br />
        There’s a lot to like bat-wise. Defensively, it’s an average profile with hopes that the stick does the talking. Since the trade, Tibbs has shown out slashing .270/.449/.459 through ten games with BABIP luck finally on his side. He’s also cut his K% down by a mind boggling 10% into the sub-20% range.
        <br /><br />
      </Typography>

      <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
        OF Zach Ehrhard
      </Typography>
      <br />
      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "13pt"
        }}
      >
        Ehrhard on the other hand is a dynamic athlete both in the box and on the grass. I’ve grown quite fond of him over this past year and was sad to see him go. He was highlighted as an under-the-radar contributor in the farm system thanks to his good swing decisions and a nifty combo of sneaky pop, high OBP ability, and speed.
        <br /><br />
        Prior to the trade, he slashed .270/.371/.434/.805 with a 134 wRC+ with a 10% BB rate and 20% K rate between High-A and Double-A. He’s made great progress in his offensive ability over the past three years including college. Ehrhard also had 23 SBs in 26 attempts with a 6.3 speed rating that ranked first among Red Sox MiLB players with 320 PA or more in High-A or higher.
        <br /><br />
        Ehrhard is sound defensively and I could see the Dodgers giving him some run at CF, though Boston mostly used him on the corners since drafting him. Looking back, he was my second-highest graded Day 2 draft pick in 2024, just behind demon left-hander Brandon Clarke. There’s a pretty decent floor of being a platoon outfielder here, with the ceiling of a steady, everyday producer.
        <br /><br />
        Since the last minute deadline deal, Ehrhard is another guy who’s shown out slashing .314/.419/.486 through nine games with a sub-10% K rate and 12% BB rate in Double-A. You love to see it.
        <br /><br />
      </Typography>

      <Typography
        variant="body2"
        style={{
          color: "rgba(0, 0, 0, 1)",
          fontSize: "15pt",
          textAlign: "center",
          fontStyle: "italic"
        }}
      >
        Thank you for reading!! For those who enjoy Red Sox content, especially of the in-depth “nerdy” variant whether it be at the major or minor league level, be sure to check out my <a href="https://x.com/ggeiss_mlb">twitter page here</a> where I post 24/7. I also cover the Red Sox independently on my <a href="https://medium.com/@ggeiss_mlb">Medium page</a> and do both regular player and fantasy baseball analysis as a contributor at <a href="https://pitcherlist.com/author/gg-geissler/">PitcherList</a>.
        <br /><br />
        — Griffey Geiss (@ggeiss_mlb)
      </Typography>
    </div>
  );
}
